import React from "react";
import {
    Box,
    Typography,
    Button,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Chip,
} from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import Rating from "@material-ui/lab/Rating";

import useStyles from "./style.js";

const PlaceDetail = ({ place, selected, refProp }) => {
    const classes = useStyles();

    if (selected)
        refProp?.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });

    return (
        <Card elevation={10} style={{ borderRadius: "20px", margin: "15px" }}>
            <CardMedia
                style={{
                    borderTopLeftRadius: "20px",
                    borderTopRightRadius: "20px",
                    height: 250,
                    margin: "1.2rem",
                }}
                image={
                    place.photo
                        ? place.photo.images.large.url
                        : "https://source.unsplash.com/1600x900/?restaurant,food"
                }
                title={place.name}
            />
            <CardContent>
                <Typography gutterBottom variant="h5">
                    {place.name}
                </Typography>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    my={2}
                    gutterBottom
                >
                    <Rating
                        name="read-only"
                        value={Number(place.rating)}
                        readOnly
                    />
                    <Typography component="legend">
                        {place.num_reviews} review{place.num_reviews > 1 && "s"}
                    </Typography>
                </Box>
                {place?.price_level && (
                    <Box display="flex" justifyContent="space-between">
                        <Typography component="legend">Price</Typography>
                        <Typography gutterBottom variant="subtitle1">
                            {place.price_level}
                        </Typography>
                    </Box>
                )}
                {place?.awards?.map((award) => (
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        my={1}
                        alignItems="center"
                    >
                        <img src={award.images.small} alt="img" />
                        <Typography variant="subtitle2" color="textSecondary">
                            {award.display_name}
                        </Typography>
                    </Box>
                ))}
                {place?.cuisine?.map(({ name }) => (
                    <Chip
                        key={name}
                        size="small"
                        label={name}
                        className={classes.chip}
                    />
                ))}
                {place.address && (
                    <Typography
                        gutterBottom
                        variant="body2"
                        color="textSecondary"
                        className={classes.subtitle}
                    >
                        <LocationOnIcon />
                        {place.address}
                    </Typography>
                )}
                {place.phone && (
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        className={classes.spacing}
                    >
                        <PhoneIcon /> {place.phone}
                    </Typography>
                )}
            </CardContent>

            <CardActions>
                <Button
                    style={{ fontWeight: "bolder" }}
                    size="small"
                    color="#141414"
                    onClick={() => window.open(place.web_url, "_blank")}
                >
                    Trip Advisor
                </Button>
                <Button
                    style={{ fontWeight: "bolder" }}
                    size="small"
                    color="#141414"
                    onClick={() => window.open(place.website, "_blank")}
                >
                    Website
                </Button>
            </CardActions>
        </Card>
    );
};

export default PlaceDetail;
